import { Injectable } from '@angular/core';
import { clone, isEqual } from 'lodash';
import moment from 'moment';
import { Subject } from 'rxjs';

/**
 * @deprecated
 */
@Injectable({
  providedIn: 'root'
})
export class ReportFilterState {
  private defaultOpenedInterval = {
    openedAt_gte: moment().subtract('1', 'month').startOf('days').format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
    openedAt_lte: moment().endOf('days').format('YYYY-MM-DDTHH:mm:ss.SSSZ')
  };

  public query: any;
  public onChangeFilter = new Subject<void>();
  public onClearFilter = new Subject<void>();
  public isFilterOn = new Subject<boolean>();

  constructor() {
    this.query = clone(this.defaultOpenedInterval);

    this.onChangeFilter.subscribe(() => {
      const queryWithoutDefaultValues = clone(this.query);

      if (queryWithoutDefaultValues.openedAt_lte === this.defaultOpenedInterval.openedAt_lte) {
        delete queryWithoutDefaultValues.openedAt_lte;
      }

      if (queryWithoutDefaultValues.openedAt_gte === this.defaultOpenedInterval.openedAt_gte) {
        delete queryWithoutDefaultValues.openedAt_gte;
      }

      return this.isFilterOn.next(!isEqual(queryWithoutDefaultValues, {}));
    });
  }
}
